<template>
  <basicContainer>
    <div>
      <avue-crud
        ref="avueCrud"
        :data="tableData"
        :option="option"
        v-model="form"
        :table-loading="TABLE_LOADING"
        :page.sync="TABLE_PAGE"
        @search-change="SEARCH_CHANGE"
        @refresh-change="TABLE_REFRESH"
        @search-reset="SEARCH_RESET"
        @cell-click="CELL_CLICK"
        @selection-change="SELECTION_CHANGE"
        @sort-change="SORT_CHANGE"
        @size-change="SIZE_CHANGE"
        @current-change="CURRENT_CHANGE"
      >
      </avue-crud>
    </div>
  </basicContainer>
</template>

<script>
import crudPageMinix from "@/businessManagement/utils/crudPageMinix.js";
export default {
  mixins: [crudPageMinix],
  data() {
    return {
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: false,
        tip: false,
        align: "left",
        menuAlign: "center",
        searchMenuSpan: 4,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        index: true,
        indexLabel: "序号",
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: false,
        menuWidth: 150,
        emptyBtn: false,
        column: [
          {
            label: "项目名称",
            prop: "xmmc",
            minWidth: 150,
            overHidden: true,
          },
          {
            label: "项目名称",
            prop: "XMMC",
            search: true,
            minWidth: 150,
            search: true,
            hide: true,
          },
          {
            label: "任务总数量",
            prop: "zrw",
            minWidth: 120,
          },
          {
            label: "总工时数",
            prop: "zgs",
            minWidth: 120,
          },
          {
            label: "本周任务数",
            prop: "thisWorkRW",
            minWidth: 120,
          },
          {
            label: "本周工时数",
            prop: "thisWorkGS",
            minWidth: 120,
          },
          {
            label: "上周任务数",
            prop: "sworkRW",
            minWidth: 120,
          },
          {
            label: "上周工时数",
            prop: "sworkGS",
            minWidth: 120,
          },
          {
            label: "上两周任务数",
            prop: "ssWorkRW",
            minWidth: 120,
          },
          {
            label: "上两周工时数",
            prop: "ssWorkGS",
            minWidth: 120,
          },
          {
            label: "上三周任务数",
            prop: "sssWorkRW",
            minWidth: 120,
          },

          {
            label: "上三周工时数",
            prop: "sssWorkGS",
            minWidth: 120,
          },
          {
            label: "上四周任务数",
            prop: "ssssWorkRW",
            minWidth: 120,
          },

          {
            label: "上四周工时数",
            prop: "ssssWorkGS",
            minWidth: 120,
          },
        ],
      },
      form: {},
      tableData: [],
    };
  },
  methods: {
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done
    ) {
      this.TABLE_LOADING = true; // 表格转圈

      this.$http
        .get("/taskDict/getRecentTasks", {
          params: {
            ...QUERY_CONDITIONS,
            pageNum: TABLE_PAGE.currentPage,
            pageSize: TABLE_PAGE.pageSize,
          },
        })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records);
          this.TABLE_PAGE.total =
            response.data.total || response.data.records.length;
          this.SELECT_LIST = [];
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message);
        })
        .finally(() => {
          this.TABLE_LOADING = false; // 表格转圈
          typeof done === "function" && done();
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
</style>